// ── Company Details ───────────────────────────────────────────────────────────
// UPDATE THESE before going live. These values are used across Footer,
// policy pages, schema markup and trust sections.

export const COMPANY = {
  name:         'Big Bird Travel and Tourism',
  shortName:    'Big Bird Travel',
  tagline:      'Your UAE-Based Travel Partner',
  email:        'info@bigbirdtravel.com',
  phone:        '+971 56 178 9642',
  whatsapp:     '971561789642',
  whatsappDisplay: '+971 56 178 9642',
  website:      'https://bigbirdtravel.com',

  address: {
    line1:    'Al Sawari Street 5, Building No-21, Office No-4',
    line2:    'Mussafah (M-13), Abu Dhabi, UAE',
    city:     'Abu Dhabi',
    emirate:  'Abu Dhabi',
    country:  'United Arab Emirates',
    googleMapsUrl: 'https://maps.google.com/?q=Al+Sawari+Street+5+Building+21+Mussafah+M-13+Abu+Dhabi+UAE',
  },

  // Trade registration
  registration: {
    tradeLicense: 'CN-5285999',
  },

  social: {
    facebook:  'https://www.facebook.com/profile.php?id=61558812744882',
    instagram: 'https://www.instagram.com/bigbirdtraveluae/',
  },

  googleMapsReview: 'https://g.page/r/CQYe636Fs95CEBM/review',
};
